// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"8434e2ec","107":"26ead8f3","148":"74c2ed0b","320":"f1c35257","453":"453f2ef2","483":"44021694","522":"d17ba89d","567":"44035cf9","639":"fb0806a8","663":"98c0b815","694":"f3012d69","845":"8784689e","899":"11425912"}[chunkId] + ".chunk.js";
};